<template>
  <svg :height="`${height}px`" :width="`${width}px`" :class="`fill-current  text-${color}`" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M24 2.8125V20.0226L22.125 18.1476V2.8125C22.125 2.29559 21.7044 1.875 21.1875 1.875H2.8125C2.29559 1.875 1.875 2.29559 1.875 2.8125V21.1875C1.875 21.7044 2.29559 22.125 2.8125 22.125H18.1476L20.0226 24H2.8125C1.2616 24 0 22.7384 0 21.1875V2.8125C0 1.2616 1.2616 0 2.8125 0H21.1875C22.7384 0 24 1.2616 24 2.8125ZM15.9375 4.21875H8.10938V6.09375H15.9375V4.21875ZM19.314 17.9883L23.5378 22.2122L22.2122 23.538L17.9883 19.3141C17.1394 19.9037 16.1094 20.25 15 20.25C12.1051 20.25 9.75 17.8949 9.75 15C9.75 12.1051 12.1051 9.75 15 9.75C17.8949 9.75 20.25 12.1051 20.25 15C20.25 16.1094 19.9037 17.1394 19.314 17.9883ZM18.375 15C18.375 13.1391 16.8609 11.625 15 11.625C13.1391 11.625 11.625 13.1391 11.625 15C11.625 16.8609 13.1391 18.375 15 18.375C16.8609 18.375 18.375 16.8609 18.375 15Z"
    />
  </svg>
</template>
<script>
export default {
  props: {
    color: {
      type: String,
      default: '#333'
    },
    width: {
      type: String,
      default: '24'
    },
    height: {
      type: String,
      default: '24'
    }
  }
}
</script>
